import React from 'react';
import { Box } from '@wix/design-system';
import { LastDaySaleBannerContent } from './LastDaySaleBannerContent';
import { SaleBannerContent } from './SaleBannerContent';
import s from './SaleBanner.scss';
import classNames from 'classnames';
import { SaleIcon as DefaultSaleIcon } from '../SaleIcon';
export const SaleBanner = ({ isLastDaySale, SaleIcon, saleEndDate, saleText, lastDaySaleText, }) => (React.createElement(Box, { dataHook: "sale-banner", className: classNames(s.saleStrip) },
    SaleIcon ?? React.createElement(DefaultSaleIcon, null),
    React.createElement(Box, { dataHook: "sale-content", padding: "13px 36px 13px 0", verticalAlign: "middle" }, isLastDaySale ? (React.createElement(LastDaySaleBannerContent, { saleText: lastDaySaleText, saleEndDate: saleEndDate })) : (React.createElement(SaleBannerContent, { saleText: saleText })))));
//# sourceMappingURL=SaleBanner.js.map